module.exports = __webpack_public_path__ + "static/media/icon-individuals-teams.5f6e6375.png";